"use client";

import { useRouter } from "next/navigation";
import { statusSecondaryButton } from "./StatusPage";

/** Back to the previous page; home when the visitor arrived straight here. */
export function GoBackButton() {
  const router = useRouter();
  return (
    <button
      type="button"
      onClick={() => (window.history.length > 1 ? router.back() : router.push("/"))}
      className={statusSecondaryButton}
    >
      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 17l-5-5m0 0l5-5m-5 5h12" />
      </svg>
      Go back
    </button>
  );
}
